import {
  ALGEBRA2_LEARNING_LABS_WORLD_SLUG,
  COLLEGE_ADMISSIONS_WORKSHOPS_WORLD_SLUG,
  DIALOGUES_WORLD_SLUG,
  PRE_CALCULUS_LEARNING_LABS_WORLD_SLUG,
  SAT_BOOTCAMP_WORLD_SLUG,
} from '@/client/services/worlds/constants'

import type { ProgramSubworldSlug } from '../worlds/types'

export const KHAN_ACADEMY_BOOTCAMP_SERIES_TEMPLATE_IDS: Record<string, number> = {
  'Polynomial Arithmetic': 6,
  Logarithms: 7,
  Trigonometry: 8,
}

export const SAT_BOOTCAMP_KEY = 'sat-bootcamp'
export const CAW_KEY = 'caw'
export const ALGEBRA2_LEARNING_LABS_KEY = 'algebra2-learning-labs'
export const PRE_CALCULUS_LEARNING_LABS_KEY = 'pre-calculus-learning-labs'
export const DIALOGUES_KEY = 'dialogues'

export const DEFAULT_PROGRAM_KEY: Record<ProgramSubworldSlug, string> = {
  'sat-bootcamp': SAT_BOOTCAMP_KEY,
  'college-admissions-workshops': CAW_KEY,
  'algebra2-learning-labs': ALGEBRA2_LEARNING_LABS_KEY,
  'pre-calculus-learning-labs': PRE_CALCULUS_LEARNING_LABS_KEY,
  dialogues: DIALOGUES_KEY,
}

export const SAT_BOOTCAMP_PROGRAM_SLUG = 'sat-bootcamp'
export const DIALOGUES_PROGRAM_SLUG = 'dialogues'
export const COLLEGE_ADMISSIONS_WORKSHOPS_PROGRAM_SLUG = 'college-admissions-workshops'
export const ALGEBRA2_LEARNING_LABS_PROGRAM_SLUG = 'algebra2-learning-labs'
export const PRE_CALCULUS_LEARNING_LABS_PROGRAM_SLUG = 'pre-calculus-learning-labs'

export const PROGRAM_SLUGS = [
  SAT_BOOTCAMP_PROGRAM_SLUG,
  COLLEGE_ADMISSIONS_WORKSHOPS_PROGRAM_SLUG,
  ALGEBRA2_LEARNING_LABS_PROGRAM_SLUG,
  PRE_CALCULUS_LEARNING_LABS_PROGRAM_SLUG,
  DIALOGUES_PROGRAM_SLUG,
] as const
export type ProgramSlug = (typeof PROGRAM_SLUGS)[number]

export const DASHBOARD_PROGRAM_SLUGS = [
  SAT_BOOTCAMP_PROGRAM_SLUG,
  COLLEGE_ADMISSIONS_WORKSHOPS_PROGRAM_SLUG,
  DIALOGUES_PROGRAM_SLUG,
] as const
export type DashboardProgramSlug = (typeof DASHBOARD_PROGRAM_SLUGS)[number]

export const PROGRAM_SLUGS_WITH_WORLD = [
  SAT_BOOTCAMP_PROGRAM_SLUG,
  COLLEGE_ADMISSIONS_WORKSHOPS_PROGRAM_SLUG,
  ALGEBRA2_LEARNING_LABS_PROGRAM_SLUG,
  PRE_CALCULUS_LEARNING_LABS_PROGRAM_SLUG,
  DIALOGUES_PROGRAM_SLUG,
] as const
export type ProgramSlugWithWorld = (typeof PROGRAM_SLUGS_WITH_WORLD)[number]

export const PROGRAM_SLUGS_WITH_ITERATIONS = [
  SAT_BOOTCAMP_PROGRAM_SLUG,
  COLLEGE_ADMISSIONS_WORKSHOPS_PROGRAM_SLUG,
  ALGEBRA2_LEARNING_LABS_PROGRAM_SLUG,
  PRE_CALCULUS_LEARNING_LABS_PROGRAM_SLUG,
  DIALOGUES_PROGRAM_SLUG,
] as const
export type ProgramSlugWithIterations = (typeof PROGRAM_SLUGS_WITH_ITERATIONS)[number]

export const PROGRAM_WORLD_TO_PROGRAM_SLUG: Record<
  ProgramSubworldSlug,
  | 'sat-bootcamp'
  | 'college-admissions-workshops'
  | 'algebra2-learning-labs'
  | 'pre-calculus-learning-labs'
  | 'dialogues'
> = {
  [SAT_BOOTCAMP_WORLD_SLUG]: SAT_BOOTCAMP_PROGRAM_SLUG,
  [COLLEGE_ADMISSIONS_WORKSHOPS_WORLD_SLUG]: COLLEGE_ADMISSIONS_WORKSHOPS_PROGRAM_SLUG,
  [ALGEBRA2_LEARNING_LABS_WORLD_SLUG]: ALGEBRA2_LEARNING_LABS_PROGRAM_SLUG,
  [PRE_CALCULUS_LEARNING_LABS_WORLD_SLUG]: PRE_CALCULUS_LEARNING_LABS_PROGRAM_SLUG,
  [DIALOGUES_WORLD_SLUG]: DIALOGUES_PROGRAM_SLUG,
} as const

export const POPULAR_RECURRING_PROGRAM_TIME_RANGES = {
  timezone: 'America/Los_Angeles',
  weekday: {
    startHour: 13,
    endHour: 18,
  },
  weekend: {
    startHour: 7,
    endHour: 18,
  },
}
